import React from 'react';
import { wellnessData, images } from '../data/mock';
import { Film, Car, Flower2, Users, Palette, TreeDeciduous } from 'lucide-react';

const activityIcons = [
  Film,
  Car,
  Flower2,
  Users,
  Palette,
  TreeDeciduous
];

const WellnessSection = () => {
  return (
    <section className="py-24 md:py-32 bg-[#FAF8F5]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Text Content */}
          <div>
            <div className="flex items-center gap-4 mb-6">
              <div className="w-12 h-px bg-[#8DA399]" />
              <span className="font-lato text-[#8DA399] uppercase tracking-[0.2em] text-xs">Lifestyle</span>
            </div>

            <h2 className="font-playfair text-4xl md:text-5xl text-[#1A2B3C] mb-6 leading-tight">
              {wellnessData.headline}
            </h2>

            <p className="font-lato text-[#1A2B3C]/70 text-lg leading-relaxed mb-10">
              {wellnessData.body}
            </p>

            {/* Activities Grid */}
            <div className="grid grid-cols-2 gap-4">
              {wellnessData.activities.map((activity, index) => {
                const IconComponent = activityIcons[index];
                return (
                  <div
                    key={index}
                    className="flex items-center gap-3 p-3 rounded-lg hover:bg-[#8DA399]/10 transition-colors duration-300"
                  >
                    <div className="w-10 h-10 rounded-full bg-[#8DA399]/20 flex items-center justify-center flex-shrink-0">
                      <IconComponent className="w-5 h-5 text-[#8DA399]" />
                    </div>
                    <span className="font-lato text-[#1A2B3C]/80 text-sm">{activity}</span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Image Grid */}
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-4">
              <div className="rounded-xl overflow-hidden shadow-lg">
                <img
                  src={images.interiors[0]}
                  alt="Luxury Lounge"
                  className="w-full h-48 object-cover hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="rounded-xl overflow-hidden shadow-lg">
                <img
                  src={images.bedrooms[0]}
                  alt="Elegant Bedroom"
                  className="w-full h-64 object-cover hover:scale-105 transition-transform duration-500"
                />
              </div>
            </div>
            <div className="space-y-4 mt-8">
              <div className="rounded-xl overflow-hidden shadow-lg">
                <img
                  src={images.wellness[0]}
                  alt="Wellness Spa"
                  className="w-full h-64 object-cover hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="rounded-xl overflow-hidden shadow-lg">
                <img
                  src={images.interiors[1]}
                  alt="Elegant Living Space"
                  className="w-full h-48 object-cover hover:scale-105 transition-transform duration-500"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WellnessSection;
